import {PhoneNumberTextField} from '@hconnect/uikit'
import {TextField} from '@material-ui/core'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {useTranslation} from '../../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../../Skeleton/UserInformationInputSkeleton'
import {UserInformationProps} from '../types'
import {useStyles} from '../UserInput.styles'

type UserMobileNumberInputProps<T extends FieldValues> = UserInformationProps<T> & {
  canEditUserEmailPhone: boolean
  userMobileNumber?: string | null
}

export const UserMobileNumberInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  canEditUserEmailPhone,
  userMobileNumber,
  isLoading,
  isQuickPreview,
  name
}: UserMobileNumberInputProps<T>) => {
  const {t} = useTranslation()
  const errors = formMethods.formState.errors
  const touched = formMethods.formState.touchedFields
  const classes = useStyles()
  const values = formMethods.watch()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }
  const hasError = !!errors.mobileNumber?.message
  const localKey = `errorMessages.${errors.mobileNumber?.message}`
  const helperText = hasError ? t(localKey) : undefined
  return (
    <>
      {userMobileNumber || !readonlyMode || isQuickPreview ? (
        <Controller
          name={name}
          control={formMethods.control}
          render={({field}) => (
            <PhoneNumberTextField
              inputRef={field.ref}
              {...field}
              data-test-id={`userInformationForm-${field.name}`}
              className={isQuickPreview ? classes.quickPreviewTextField : classes.textField}
              fullWidth
              id="mobileNumber"
              label={t('userInformationForm.mobileNumber')}
              defaultValue={values.mobileNumber}
              onPhoneChange={(phoneNumber) => {
                formMethods.setValue(name, phoneNumber as any, {
                  shouldTouch: true,
                  shouldDirty: true
                })
              }}
              margin="normal"
              error={touched['mobileNumber'] && hasError}
              helperText={helperText}
              style={{maxWidth: isQuickPreview ? undefined : 400}}
              disabled={!canEditUserEmailPhone}
              InputLabelProps={{shrink: isQuickPreview ? true : undefined}}
              InputProps={{
                readOnly: readonlyMode,
                disableUnderline: readonlyMode || isQuickPreview,
                style: readonlyMode
                  ? {width: isQuickPreview ? undefined : 260}
                  : {maxWidth: isQuickPreview ? undefined : 400}
              }}
              options={{nationalMode: !readonlyMode, allowDropdown: !readonlyMode}}
              readonlyMode={readonlyMode}
            />
          )}
        />
      ) : (
        <TextField
          label={t('userInformationForm.mobileNumber')}
          value="-"
          InputProps={{readOnly: true, disableUnderline: true}}
          InputLabelProps={{shrink: true}}
          margin="normal"
          fullWidth
        />
      )}
    </>
  )
}
